import { FocusTrap } from './FocusTrap';
import type { FocusTrapOptions } from './FocusTrapManager';
import { FocusTrapManager } from './FocusTrapManager';

export type FocusTrapInstance = FocusTrap;

export type { FocusTrapOptions };

/**
 * Функция для создания ловушки фокуса
 */
export function createFocusTrap(scope: HTMLElement, options: FocusTrapOptions = {}) {
    const manager = FocusTrapManager.getInstance();

    return new FocusTrap(manager, scope, options);
}
